import React from "react"
import styled from "styled-components"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import logoImage from "../../img/origin-restaurant.png"
import { globalHistory as history } from "@reach/router"
import { animateScroll as scroll } from "react-scroll"

const StyledLogoWrapper = styled.div`
  height: 120px;
  padding: 12px 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  box-sizing: border-box;

  @media (max-width: 419px) {
    height: 96px;
  }
`

const StyledLogoLink = styled(AniLink)`
  height: 100%;
  display: flex;
  align-items: center;
`

const StyledLogo = styled.img`
  cursor: pointer;
  height: 100%;
  width: auto;
  max-width: 320px;
  object-fit: contain;
  display: block;
`

export default function Branding() {
  const { location } = history
  const path = location.pathname
  return (
    <StyledLogoWrapper>
      {path === "/" ? (
        <StyledLogo
          src={logoImage}
          alt="Origin Restaurant logo"
          onClick={() => scroll.scrollTo(0)}
        ></StyledLogo>
      ) : (
        <StyledLogoLink to="/" cover direction="right" duration={1} bg="#968b63">
          <StyledLogo src={logoImage} alt="Origin Restaurant logo" />
        </StyledLogoLink>
      )}
    </StyledLogoWrapper>
  )
}
